/* 실시간 관측정보 */

import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./layout";
import "./realtime.css";
import useInterval from "./interval";

const Realtime = () => {
  const customSlider = React.createRef();
  const [sliderSettings] = React.useState({
    dots: true, // 페이지네이션
    // fade: true, // 슬라이드 종류 fade slide
    slidesToShow: 2, // 한 화면에 보여줄 아이템 수
    slidesToScroll: 2, // 한번에 슬라이드 시킬 아이템 수
    speed: false, // 슬라이드 애니메이션 속도
    autoplay: true, // 자동재생
    Infinite: true, // 무한반복
    autoplaySpeed: 3000, // 자동플레이 슬라이드 속도
    arrows: true, // 화살표
    pauseOnHover: false, // 마우스올려도 동영상계속재생
    dotsClass: "dots_custom", // dot custom
    arrowsClass: "arrows_custom",
    mobileFirst: true, // mobile 세팅을 가능하게 해줌.
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          vertical: true, // 세로 방향으로 나타내기
          dots: true,
        },
      },
    ],
  });

  // 일출정보 불러오기
  const [sunrise, setSunrise] = React.useState({
    일출: "",
    일몰: "",
  });
  React.useEffect(() => {
    fetch("http://222.239.231.149:8080/dashboard/yeongam/data/youngamSun.json")
      .then((res) => res.json())
      .then((data) => {
        setSunrise(data);
      });
  }, []);
  useInterval(() => {
    fetch("http://222.239.231.149:8080/dashboard/yeongam/data/youngamSun.json")
      .then((res) => res.json())
      .then((data) => {
        setSunrise(data);
      });
  }, 60000);

  // play, stop button
  const slidePlay = () => {
    customSlider.current.slickPlay();
  };

  const slidePause = () => {
    customSlider.current.slickPause();
  };

  const [play, pause] = React.useState(false);

  //

  const [realtime, setRealtime] = React.useState([
    {
      업데이트시간: "",
      발전량: "",
      내기온도: "",
      외기온도: "",
      풍향: "",
      풍속: "",
    },
    {
      업데이트시간: "",
      발전량: "",
      내기온도: "",
      외기온도: "",
      풍향: "",
      풍속: "",
    },
    {
      업데이트시간: "",
      발전량: "",
      내기온도: "",
      외기온도: "",
      풍향: "",
      풍속: "",
    },
    {
      업데이트시간: "",
      발전량: "",
      내기온도: "",
      외기온도: "",
      풍향: "",
      풍속: "",
    },
    {
      업데이트시간: "",
      발전량: "",
      내기온도: "",
      외기온도: "",
      풍향: "",
      풍속: "",
    },
    {
      업데이트시간: "",
      발전량: "",
      내기온도: "",
      외기온도: "",
      풍향: "",
      풍속: "",
    },
    {
      업데이트시간: "",
      발전량: "",
      내기온도: "",
      외기온도: "",
      풍향: "",
      풍속: "",
    },
    {
      업데이트시간: "",
      발전량: "",
      내기온도: "",
      외기온도: "",
      풍향: "",
      풍속: "",
    },
    {
      업데이트시간: "",
      발전량: "",
      내기온도: "",
      외기온도: "",
      풍향: "",
      풍속: "",
    },
    {
      업데이트시간: "",
      발전량: "",
      내기온도: "",
      외기온도: "",
      풍향: "",
      풍속: "",
    },
    {
      업데이트시간: "",
      발전량: "",
      내기온도: "",
      외기온도: "",
      풍향: "",
      풍속: "",
    },
    {
      업데이트시간: "",
      발전량: "",
      내기온도: "",
      외기온도: "",
      풍향: "",
      풍속: "",
    },
    {
      업데이트시간: "",
      발전량: "",
      내기온도: "",
      외기온도: "",
      풍향: "",
      풍속: "",
    },
    {
      업데이트시간: "",
      발전량: "",
      내기온도: "",
      외기온도: "",
      풍향: "",
      풍속: "",
    },
    {
      업데이트시간: "",
      발전량: "",
      내기온도: "",
      외기온도: "",
      풍향: "",
      풍속: "",
    },
    {
      업데이트시간: "",
      발전량: "",
      내기온도: "",
      외기온도: "",
      풍향: "",
      풍속: "",
    },
    {
      업데이트시간: "",
      발전량: "",
      내기온도: "",
      외기온도: "",
      풍향: "",
      풍속: "",
    },
    {
      업데이트시간: "",
      발전량: "",
      내기온도: "",
      외기온도: "",
      풍향: "",
      풍속: "",
    },
    {
      업데이트시간: "",
      발전량: "",
      내기온도: "",
      외기온도: "",
      풍향: "",
      풍속: "",
    },
    {
      업데이트시간: "",
      발전량: "",
      내기온도: "",
      외기온도: "",
      풍향: "",
      풍속: "",
    },
  ]);
  useInterval(() => {
    fetch("http://222.239.231.149:8080/dashboard/yeongam/data/wind10min.json")
      .then((res) => res.json())
      .then((data) => {
        setRealtime(data);
      });
  }, 60000);

  React.useEffect(() => {
    fetch("http://222.239.231.149:8080/dashboard/yeongam/data/wind10min.json")
      .then((response) => response.json())
      .then((data) => {
        setRealtime(data);
      });
  }, []);
  return (
    <div className="live">
      <div className="liveheader">
        <span className="livename">실시간 관측 정보</span>
        <ul className="sun">
          <li>
            <img
              className="sunrise"
              src={process.env.PUBLIC_URL + "/img/sunrise_white.png"}
              alt="일출"
            />
          </li>
          <li>
            <span className="sunRdata">{sunrise["일출"]}</span>
          </li>
          <li>
            <img
              className="sunset"
              src={process.env.PUBLIC_URL + "/img/sunset_white.png"}
              alt="일몰"
            />
          </li>
          <li>
            <span className="sunSdata">{sunrise["일몰"]}</span>
          </li>
          <li>
            {/* play,stop button */}
            <span
              onClick={() => {
                pause((e) => !e);
              }}
            >
              {play ? (
                <img
                  className="livepauseBtn"
                  src={process.env.PUBLIC_URL + "/img/play_white.png"}
                  alt="play"
                  onClick={slidePlay}
                />
              ) : (
                <img
                  className="liveplayBtn"
                  src={process.env.PUBLIC_URL + "/img/pause_white.png"}
                  alt="pause"
                  onClick={slidePause}
                />
              )}
            </span>
          </li>
        </ul>
      </div>
      <div className="realdata">
        <Slider className="mwslider" {...sliderSettings} ref={customSlider}>
          <div className="slide">
            <table className="table">
              <thead></thead>
              <caption className="caption">1 호기</caption>
              <tbody>
                <tr>
                  <th className="main">
                    발&nbsp;&nbsp;&nbsp;전&nbsp;&nbsp;&nbsp;량
                  </th>
                  <td className="maindata">{realtime[0]["발전량"]}</td>
                  <td className="unit">kW</td>
                </tr>
                <tr>
                  <th className="main">
                    풍&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;속
                  </th>
                  <td className="mw">
                    {realtime[0]["풍향"]}, {realtime[0]["풍속"]}
                  </td>
                  <td className="unit">m/s</td>
                </tr>
                <tr>
                  <th className="main">외&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[0]["외기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
                <tr>
                  <th className="main">내&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[0]["내기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="slide">
            <table className="table">
              <thead></thead>
              <caption className="caption">2 호기</caption>
              <tbody>
                <tr>
                  <th className="main">
                    발&nbsp;&nbsp;&nbsp;전&nbsp;&nbsp;&nbsp;량
                  </th>
                  <td className="maindata">{realtime[1]["발전량"]}</td>
                  <td className="unit">kW</td>
                </tr>
                <tr>
                  <th className="main">
                    풍&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;속
                  </th>
                  <td className="mw">
                    {realtime[1]["풍향"]}, {realtime[1]["풍속"]}
                  </td>
                  <td className="unit">m/s</td>
                </tr>
                <tr>
                  <th className="main">외&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[1]["외기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
                <tr>
                  <th className="main">내&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[1]["내기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
              </tbody>
            </table>
            <span className="timeline">
              update {realtime[1]["업데이트시간"]}
            </span>
          </div>
          <div className="slide">
            <table className="table">
              <thead></thead>
              <caption className="caption">3 호기</caption>
              <tbody>
                <tr>
                  <th className="main">
                    발&nbsp;&nbsp;&nbsp;전&nbsp;&nbsp;&nbsp;량
                  </th>
                  <td className="maindata">{realtime[2]["발전량"]}</td>
                  <td className="unit">kW</td>
                </tr>
                <tr>
                  <th className="main">
                    풍&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;속
                  </th>
                  <td className="mw">
                    {realtime[2]["풍향"]}, {realtime[2]["풍속"]}
                  </td>
                  <td className="unit">m/s</td>
                </tr>
                <tr>
                  <th className="main">외&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[2]["외기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
                <tr>
                  <th className="main">내&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[2]["내기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="slide">
            <table className="table">
              <thead></thead>
              <caption className="caption">4 호기</caption>
              <tbody>
                <tr>
                  <th className="main">
                    발&nbsp;&nbsp;&nbsp;전&nbsp;&nbsp;&nbsp;량
                  </th>
                  <td className="maindata">{realtime[3]["발전량"]}</td>
                  <td className="unit">kW</td>
                </tr>
                <tr>
                  <th className="main">
                    풍&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;속
                  </th>
                  <td className="mw">
                    {realtime[3]["풍향"]}, {realtime[3]["풍속"]}
                  </td>
                  <td className="unit">m/s</td>
                </tr>
                <tr>
                  <th className="main">외&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[3]["외기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
                <tr>
                  <th className="main">내&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[3]["내기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
              </tbody>
            </table>
            <span className="timeline">
              update {realtime[1]["업데이트시간"]}
            </span>
          </div>
          <div className="slide">
            <table className="table">
              <thead></thead>
              <caption className="caption">5 호기</caption>
              <tbody>
                <tr>
                  <th className="main">
                    발&nbsp;&nbsp;&nbsp;전&nbsp;&nbsp;&nbsp;량
                  </th>
                  <td className="maindata">{realtime[4]["발전량"]}</td>
                  <td className="unit">kW</td>
                </tr>
                <tr>
                  <th className="main">
                    풍&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;속
                  </th>
                  <td className="mw">
                    {realtime[4]["풍향"]}, {realtime[4]["풍속"]}
                  </td>
                  <td className="unit">m/s</td>
                </tr>
                <tr>
                  <th className="main">외&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[4]["외기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
                <tr>
                  <th className="main">내&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[4]["내기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="slide">
            <table className="table">
              <thead></thead>
              <caption className="caption">6 호기</caption>
              <tbody>
                <tr>
                  <th className="main">
                    발&nbsp;&nbsp;&nbsp;전&nbsp;&nbsp;&nbsp;량
                  </th>
                  <td className="maindata">{realtime[5]["발전량"]}</td>
                  <td className="unit">kW</td>
                </tr>
                <tr>
                  <th className="main">
                    풍&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;속
                  </th>
                  <td className="mw">
                    {realtime[5]["풍향"]}, {realtime[5]["풍속"]}
                  </td>
                  <td className="unit">m/s</td>
                </tr>
                <tr>
                  <th className="main">외&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[5]["외기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
                <tr>
                  <th className="main">내&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[5]["내기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
              </tbody>
            </table>
            <span className="timeline">
              update {realtime[1]["업데이트시간"]}
            </span>
          </div>
          <div className="slide">
            <table className="table">
              <thead></thead>
              <caption className="caption">7 호기</caption>
              <tbody>
                <tr>
                  <th className="main">
                    발&nbsp;&nbsp;&nbsp;전&nbsp;&nbsp;&nbsp;량
                  </th>
                  <td className="maindata">{realtime[6]["발전량"]}</td>
                  <td className="unit">kW</td>
                </tr>
                <tr>
                  <th className="main">
                    풍&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;속
                  </th>
                  <td className="mw">
                    {realtime[6]["풍향"]}, {realtime[6]["풍속"]}
                  </td>
                  <td className="unit">m/s</td>
                </tr>
                <tr>
                  <th className="main">외&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[6]["외기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
                <tr>
                  <th className="main">내&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[6]["내기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="slide">
            <table className="table">
              <thead></thead>
              <caption className="caption">8 호기</caption>
              <tbody>
                <tr>
                  <th className="main">
                    발&nbsp;&nbsp;&nbsp;전&nbsp;&nbsp;&nbsp;량
                  </th>
                  <td className="maindata">{realtime[7]["발전량"]}</td>
                  <td className="unit">kW</td>
                </tr>
                <tr>
                  <th className="main">
                    풍&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;속
                  </th>
                  <td className="mw">
                    {realtime[7]["풍향"]}, {realtime[7]["풍속"]}
                  </td>
                  <td className="unit">m/s</td>
                </tr>
                <tr>
                  <th className="main">외&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[7]["외기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
                <tr>
                  <th className="main">내&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[7]["내기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
              </tbody>
            </table>
            <span className="timeline">
              update {realtime[1]["업데이트시간"]}
            </span>
          </div>
          <div className="slide">
            <table className="table">
              <thead></thead>
              <caption className="caption">9 호기</caption>
              <tbody>
                <tr>
                  <th className="main">
                    발&nbsp;&nbsp;&nbsp;전&nbsp;&nbsp;&nbsp;량
                  </th>
                  <td className="maindata">{realtime[8]["발전량"]}</td>
                  <td className="unit">kW</td>
                </tr>
                <tr>
                  <th className="main">
                    풍&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;속
                  </th>
                  <td className="mw">
                    {realtime[8]["풍향"]}, {realtime[8]["풍속"]}
                  </td>
                  <td className="unit">m/s</td>
                </tr>
                <tr>
                  <th className="main">외&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[8]["외기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
                <tr>
                  <th className="main">내&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[8]["내기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="slide">
            <table className="table">
              <thead></thead>
              <caption className="caption">10 호기</caption>
              <tbody>
                <tr>
                  <th className="main">
                    발&nbsp;&nbsp;&nbsp;전&nbsp;&nbsp;&nbsp;량
                  </th>
                  <td className="maindata">{realtime[9]["발전량"]}</td>
                  <td className="unit">kW</td>
                </tr>
                <tr>
                  <th className="main">
                    풍&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;속
                  </th>
                  <td className="mw">
                    {realtime[9]["풍향"]}, {realtime[9]["풍속"]}
                  </td>
                  <td className="unit">m/s</td>
                </tr>
                <tr>
                  <th className="main">외&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[9]["외기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
                <tr>
                  <th className="main">내&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[9]["내기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
              </tbody>
            </table>
            <span className="timeline">
              update {realtime[1]["업데이트시간"]}
            </span>
          </div>
          <div className="slide">
            <table className="table">
              <thead></thead>
              <caption className="caption">11 호기</caption>
              <tbody>
                <tr>
                  <th className="main">
                    발&nbsp;&nbsp;&nbsp;전&nbsp;&nbsp;&nbsp;량
                  </th>
                  <td className="maindata">{realtime[10]["발전량"]}</td>
                  <td className="unit">kW</td>
                </tr>
                <tr>
                  <th className="main">
                    풍&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;속
                  </th>
                  <td className="mw">
                    {realtime[10]["풍향"]}, {realtime[10]["풍속"]}
                  </td>
                  <td className="unit">m/s</td>
                </tr>
                <tr>
                  <th className="main">외&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[10]["외기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
                <tr>
                  <th className="main">내&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[10]["내기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="slide">
            <table className="table">
              <thead></thead>
              <caption className="caption">12 호기</caption>
              <tbody>
                <tr>
                  <th className="main">
                    발&nbsp;&nbsp;&nbsp;전&nbsp;&nbsp;&nbsp;량
                  </th>
                  <td className="maindata">{realtime[11]["발전량"]}</td>
                  <td className="unit">kW</td>
                </tr>
                <tr>
                  <th className="main">
                    풍&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;속
                  </th>
                  <td className="mw">
                    {realtime[11]["풍향"]}, {realtime[11]["풍속"]}
                  </td>
                  <td className="unit">m/s</td>
                </tr>
                <tr>
                  <th className="main">외&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[11]["외기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
                <tr>
                  <th className="main">내&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[11]["내기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
              </tbody>
            </table>
            <span className="timeline">
              update {realtime[1]["업데이트시간"]}
            </span>
          </div>
          <div className="slide">
            <table className="table">
              <thead></thead>
              <caption className="caption">13 호기</caption>
              <tbody>
                <tr>
                  <th className="main">
                    발&nbsp;&nbsp;&nbsp;전&nbsp;&nbsp;&nbsp;량
                  </th>
                  <td className="maindata">{realtime[12]["발전량"]}</td>
                  <td className="unit">kW</td>
                </tr>
                <tr>
                  <th className="main">
                    풍&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;속
                  </th>
                  <td className="mw">
                    {realtime[12]["풍향"]}, {realtime[12]["풍속"]}
                  </td>
                  <td className="unit">m/s</td>
                </tr>
                <tr>
                  <th className="main">외&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[12]["외기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
                <tr>
                  <th className="main">내&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[12]["내기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="slide">
            <table className="table">
              <thead></thead>
              <caption className="caption">14 호기</caption>
              <tbody>
                <tr>
                  <th className="main">
                    발&nbsp;&nbsp;&nbsp;전&nbsp;&nbsp;&nbsp;량
                  </th>
                  <td className="maindata">{realtime[13]["발전량"]}</td>
                  <td className="unit">kW</td>
                </tr>
                <tr>
                  <th className="main">
                    풍&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;속
                  </th>
                  <td className="mw">
                    {realtime[13]["풍향"]}, {realtime[13]["풍속"]}
                  </td>
                  <td className="unit">m/s</td>
                </tr>
                <tr>
                  <th className="main">외&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[13]["외기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
                <tr>
                  <th className="main">내&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[13]["내기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
              </tbody>
            </table>
            <span className="timeline">
              update {realtime[1]["업데이트시간"]}
            </span>
          </div>
          <div className="slide">
            <table className="table">
              <thead></thead>
              <caption className="caption">15 호기</caption>
              <tbody>
                <tr>
                  <th className="main">
                    발&nbsp;&nbsp;&nbsp;전&nbsp;&nbsp;&nbsp;량
                  </th>
                  <td className="maindata">{realtime[14]["발전량"]}</td>
                  <td className="unit">kW</td>
                </tr>
                <tr>
                  <th className="main">
                    풍&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;속
                  </th>
                  <td className="mw">
                    {realtime[14]["풍향"]}, {realtime[14]["풍속"]}
                  </td>
                  <td className="unit">m/s</td>
                </tr>
                <tr>
                  <th className="main">외&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[14]["외기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
                <tr>
                  <th className="main">내&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[14]["내기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="slide">
            <table className="table">
              <thead></thead>
              <caption className="caption">16 호기</caption>
              <tbody>
                <tr>
                  <th className="main">
                    발&nbsp;&nbsp;&nbsp;전&nbsp;&nbsp;&nbsp;량
                  </th>
                  <td className="maindata">{realtime[15]["발전량"]}</td>
                  <td className="unit">kW</td>
                </tr>
                <tr>
                  <th className="main">
                    풍&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;속
                  </th>
                  <td className="mw">
                    {realtime[15]["풍향"]}, {realtime[15]["풍속"]}
                  </td>
                  <td className="unit">m/s</td>
                </tr>
                <tr>
                  <th className="main">외&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[15]["외기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
                <tr>
                  <th className="main">내&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[15]["내기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
              </tbody>
            </table>
            <span className="timeline">
              update {realtime[1]["업데이트시간"]}
            </span>
          </div>
          <div className="slide">
            <table className="table">
              <thead></thead>
              <caption className="caption">17 호기</caption>
              <tbody>
                <tr>
                  <th className="main">
                    발&nbsp;&nbsp;&nbsp;전&nbsp;&nbsp;&nbsp;량
                  </th>
                  <td className="maindata">{realtime[16]["발전량"]}</td>
                  <td className="unit">kW</td>
                </tr>
                <tr>
                  <th className="main">
                    풍&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;속
                  </th>
                  <td className="mw">
                    {realtime[16]["풍향"]}, {realtime[16]["풍속"]}
                  </td>
                  <td className="unit">m/s</td>
                </tr>
                <tr>
                  <th className="main">외&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[16]["외기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
                <tr>
                  <th className="main">내&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[16]["내기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="slide">
            <table className="table">
              <thead></thead>
              <caption className="caption">18 호기</caption>
              <tbody>
                <tr>
                  <th className="main">
                    발&nbsp;&nbsp;&nbsp;전&nbsp;&nbsp;&nbsp;량
                  </th>
                  <td className="maindata">{realtime[17]["발전량"]}</td>
                  <td className="unit">kW</td>
                </tr>
                <tr>
                  <th className="main">
                    풍&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;속
                  </th>
                  <td className="mw">
                    {realtime[17]["풍향"]}, {realtime[17]["풍속"]}
                  </td>
                  <td className="unit">m/s</td>
                </tr>
                <tr>
                  <th className="main">외&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[17]["외기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
                <tr>
                  <th className="main">내&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[17]["내기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
              </tbody>
            </table>
            <span className="timeline">
              update {realtime[1]["업데이트시간"]}
            </span>
          </div>
          <div className="slide">
            <table className="table">
              <thead></thead>
              <caption className="caption">19 호기</caption>
              <tbody>
                <tr>
                  <th className="main">
                    발&nbsp;&nbsp;&nbsp;전&nbsp;&nbsp;&nbsp;량
                  </th>
                  <td className="maindata">{realtime[18]["발전량"]}</td>
                  <td className="unit">kW</td>
                </tr>
                <tr>
                  <th className="main">
                    풍&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;속
                  </th>
                  <td className="mw">
                    {realtime[18]["풍향"]}, {realtime[18]["풍속"]}
                  </td>
                  <td className="unit">m/s</td>
                </tr>
                <tr>
                  <th className="main">외&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[18]["외기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
                <tr>
                  <th className="main">내&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[18]["내기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="slide">
            <table className="table">
              <thead></thead>
              <caption className="caption">20 호기</caption>
              <tbody>
                <tr>
                  <th className="main">
                    발&nbsp;&nbsp;&nbsp;전&nbsp;&nbsp;&nbsp;량
                  </th>
                  <td className="maindata">{realtime[19]["발전량"]}</td>
                  <td className="unit">kW</td>
                </tr>
                <tr>
                  <th className="main">
                    풍&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;속
                  </th>
                  <td className="mw">
                    {realtime[19]["풍향"]}, {realtime[19]["풍속"]}
                  </td>
                  <td className="unit">m/s</td>
                </tr>
                <tr>
                  <th className="main">외&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[19]["외기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
                <tr>
                  <th className="main">내&nbsp;기&nbsp;온&nbsp;도</th>
                  <td className="mw">{realtime[19]["내기온도"]}</td>
                  <td className="unit">℃</td>
                </tr>
              </tbody>
            </table>
            <span className="timeline">
              update {realtime[1]["업데이트시간"]}
            </span>
          </div>
        </Slider>
        <span className="mtimeline">update {realtime[1]["업데이트시간"]}</span>
      </div>
    </div>
  );
};

export default Realtime;
